import '../scss/app.scss';
import 'swiper/swiper-bundle.min.css';
import 'select2/dist/css/select2.min.css';
import '@chenfengyuan/datepicker/dist/datepicker.min.css';
import 'suggestions-jquery/dist/css/suggestions.min.css';
import $ from 'jquery';
import {
  burgerInit,
  LanguageSelect,
  cookiesInit,
  onlineTranslationInit,
  select2Init,
  RegisterForm,
  initEditControl,
  emailValidationInit,
  initCitySelect,
  initScheduleFilter,
  registrationTabs,
  hiddenSpecializations,
  ratingStars,
  exhibition,
  datepickerInit,
  accountEdit,
  accountDocument,
  accountChangePassword,
  pcCycleRegisterSpoiler,
  pcCycleRegisterEdit,
  phoneSelect,
  snilsMask,
  pcCycleDocumentRegister,
  pcCycleRegisterSnils,
} from '@/components';
import {
  popupAccessInit,
  popupAlreadyRegister,
  popupEmailInit,
  popupInit,
  popupLectorInit,
  popupLectorSendReview,
  popupRating,
} from '@/popups';
import moment from 'moment';
import 'moment/locale/ru';
import {
  dataBaseSlider,
  homeSlider,
  lectorReviewSlider,
  speakersSlider,
} from '@/components/sliders';
import {
  eventFileUploader,
  EventPage,
  eventResult,
  EventsCalendar,
} from '@/components/events';
import { exhibitionFormControl } from '@/components/exhibition-form-control';
import {
  dadataAddress,
  dadataCity,
  dadataCountry,
  dadataName,
  dadataPatronymic,
  dadataSurname,
} from '@/components/dadata';
import {
  AccountFilters,
  CyclePcEventFilter,
  CyclesPcFilter,
  EventsDatesFilter,
  LectorsFilter,
} from '@/components/filters';

$(document).ready(init);

function init() {
  /*
   * Глобальные компоненты
   * */

  moment.updateLocale($('html').attr('lang'));
  const languageSelect = new LanguageSelect();
  languageSelect.initSelect();
  burgerInit();
  cookiesInit();
  hiddenSpecializations();
  exhibitionFormControl();

  /*
   * Инициализация селектов
   * */
  select2Init();
  /*
   * Инициализация селекта городов с собственным значением
   * */
  initCitySelect();
  /*
   * Инициализация контролов с кнопкой редактирования
   * */
  initEditControl();
  /*
   * Инициализация контролов с валидацией email
   * */
  emailValidationInit();
  /*
   * Инициализация выбора маски телефона
   * */
  phoneSelect();

  /*
   * Инициализация селекта рейтинга
   * */
  ratingStars();

  /*
   * Инициализация дата пикеров
   * */
  datepickerInit();

  /*
   * Popups
   * */

  popupInit();
  popupAccessInit();
  popupRating();
  popupEmailInit();
  popupLectorInit();
  popupLectorSendReview();
  popupAlreadyRegister();

  /*
   * Слайдеры
   * */

  homeSlider();
  dataBaseSlider();
  speakersSlider();
  lectorReviewSlider();

  /*
   * Dadata
   * */

  dadataCountry();
  dadataCity();
  dadataName();
  dadataSurname();
  dadataPatronymic();
  dadataAddress();

  /*
   * Инициализация расписания мероприятий
   * */
  const $events = $('.events-list');
  if ($events && $events.length > 0) {
    const eventsCalendar = new EventsCalendar();
    eventsCalendar.initEvents();
  }

  /*
   * Инициализация элементов формы регистрации
   * */
  const $register = $('.section-register');
  if ($register && $register.length > 0) {
    const registerForm = new RegisterForm();
    registerForm.init();
  }

  initScheduleFilter();
  registrationTabs();

  /*
   * Инициализация страницы мероприятия
   * */

  const eventPage = new EventPage();
  eventPage.init();
  eventFileUploader();
  eventResult();

  /*
   * Инициализация страницы трансляции
   * */

  onlineTranslationInit();

  /*
   * Инициализация партнера выставки
   * */

  exhibition();

  /*
   * Инициализация редактирования аккаунта
   * */

  accountEdit();

  /*
   * Инициализация документов аккаунта
   * */

  accountDocument();

  /*
   * Смена пароля в аккаунте
   * */

  accountChangePassword();

  /*
   * Спойлер для регистрации цикл пк
   * */

  pcCycleRegisterSpoiler();

  /*
   * Редактирование для регистрации цикл пк
   * */

  pcCycleRegisterEdit();

  snilsMask();

  pcCycleDocumentRegister();

  pcCycleRegisterSnils();

  /*
   *  Фильтры
   * */

  new EventsDatesFilter();
  new CyclesPcFilter();
  new CyclePcEventFilter();
  new LectorsFilter();
  new AccountFilters();
}
